// extracted by mini-css-extract-plugin
export default {"seasonalFontButtonText":"cMwqyRl9k8CJ_i9U2Fi1"};